import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import type { FieldTypeDefinition, FieldRendererProps } from '../registry';
import { OptionsEditor } from '../shared/OptionsEditor';

function DropdownRenderer({ field, value, onChange, readOnly }: FieldRendererProps) {
  const options = field.options ?? [];
  const selected = options.find((o) => o.value === value) ?? null;
  return (
    <DropDownList
      data={options}
      textField="label"
      dataItemKey="id"
      value={selected}
      onChange={(e) => onChange(e.value ? e.value.value : null)}
      disabled={readOnly}
    />
  );
}

export const definition: FieldTypeDefinition = {
  key: 'DDL',
  label: 'Dropdown',
  category: 'choice',
  icon: <FontAwesomeIcon icon={faCaretDown} fixedWidth />,
  defaultProps: {
    label: 'New dropdown',
    isRequired: false,
    options: [
      { id: 'o1', value: 'option-1', label: 'Option 1', order: 0 },
      { id: 'o2', value: 'option-2', label: 'Option 2', order: 1 },
    ],
  },
  Renderer: DropdownRenderer,
  PropertyEditor: OptionsEditor,
};
